export default class WineFilters {
  constructor(page, bar, dialog) {
    this.page = page;
    this.bar = bar;
    this.dialog = dialog;
    this.appliedCollections = [];
    this.appliedVineyards = [];
    this.opened = false;
    this.btnClose = this.dialog?.querySelector(".js-dialog-filter-header");
    this.btnClearFilters = this.dialog?.querySelector(".js-btn-clear-filters");
    this.accordions = this.dialog?.querySelectorAll(".js-filter-accordion");
    this.sections = this.page?.querySelectorAll(".js-section-wines");
    this.products = this.page?.querySelectorAll(".js-wine");
    this.filters = this.dialog?.querySelectorAll(".js-filter");
    this.timing;
  }

  init() {
    this.dialog?.addEventListener("close", (e) => {
      this.opened = false;
    });

    this.btnClose?.addEventListener("click", (e) => this.close());

    this.initAccordions();    

    this.initFilters();

    this.btnClearFilters?.addEventListener("click", (e) => {
      this.appliedCollections = [];
      this.appliedVineyards = [];
      this.filterCollections();
      this.filterVineyards();
      this.filters?.forEach(f => f.classList.remove("is-checked"));
      this.scrollTop();
    });
  }

  get isOpen() {
    return this.opened;
  }

  open() {
    this.dialog?.showModal();
    this.opened = true;
  }

  close() {
    this.dialog?.close();
    this.opened = false;
  }  

  initFilters() {
    this.filters?.forEach((filter) => {     
      const type = filter?.dataset.type;
      const value = filter?.dataset.value;

      /**
       * da generalizzare...
       * */

      filter.addEventListener("click", (e) => {
        const checked = filter.classList.contains("is-checked");

        !checked
          ? filter.classList.add("is-checked")
          : filter.classList.remove("is-checked");

        if (!value && !type) return;

        if (type === "collection") {
          if (!checked) {
            !this.appliedCollections.includes(value)
              && this.appliedCollections.push(value);

          } else {
            this.appliedCollections = this.appliedCollections.filter(el => el !== value);
          }

          this.filterCollections();

        } else {
          if (!checked) {
            !this.appliedVineyards.includes(value)
              && this.appliedVineyards.push(value);

          } else {
            this.appliedVineyards = this.appliedVineyards.filter(el => el !== value);
          }

          this.filterVineyards();

          // check on other collections      
          this.sections?.forEach((section) => {
            const wines = section.querySelectorAll(".js-wine");
            Array.from(wines)?.every(w => w.classList.contains("is-hidden"))
              ? section.classList.add("is-hidden")
              : section.classList.remove("is-hidden");
          });
        }

        this.scrollTop();       

        ScrollTrigger.refresh();
      });
    });
  }

  scrollTop() {
    clearTimeout(this.timing);
    this.timing = setTimeout(() => {
      window.scrollTo({
        top: window.innerHeight,
        left: 0,
        behavior: "smooth"
      });
    }, 250);
  }

  filterVineyards() {
    this.products?.forEach((product) => product.classList.remove("is-hidden"));

    if (this.appliedVineyards?.length) {
      const toHide = Array.from(this.products)?.filter(p => !this.appliedVineyards.includes(p.dataset.vineyard));
      toHide?.forEach(el => el.classList.add("is-hidden"));      
    }
  }

  filterCollections() {
    this.sections?.forEach((section) => section.classList.remove("is-hidden"));

    if (this.appliedCollections?.length) {
      const toHide = Array.from(this.sections)?.filter(section => !this.appliedCollections.includes(section.dataset?.value));
      toHide?.forEach(el => el.classList.add("is-hidden"));
    }        
  }

  initAccordions() {
    this.accordions?.forEach((accordion, i) => {
      let open = false;

      if (i === 0) {
        open = true;
        accordion.classList.add("is-open");
        $(".js-accordion-body", accordion)?.slideDown();
      }

      $(".js-btn-toggle-accordion", accordion)?.on("click", (e) => {
        $(accordion).toggleClass("is-open");

        !open
          ? $(".js-accordion-body", accordion)?.slideDown()
          : $(".js-accordion-body", accordion)?.slideUp();

        open = !open;
      });
    });
  }
}